import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const filter: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M10.969-9.703q.124.329-.11.547L7-5.296V.5a.49.49 0 0 1-.297.469A.8.8 0 0 1 6.5 1a.47.47 0 0 1-.344-.14l-2-2.016A.44.44 0 0 1 4-1.5v-3.797L.156-9.157q-.248-.217-.11-.546A.455.455 0 0 1 .5-10h10c.219 0 .375.102.469.297m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0.003 10)"
    />
  ),
  svgProps: {
    height: "11",
    width: "11.015",
  }
};
